import * as React from 'react';
import injectSheet from 'react-jss';
import Navbar from 'src/components/navbar/Navbar';
const error404Image = require('src/assets/images/error404.gif');
const styles = (theme:any) => ({
  notFound: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    height: '100%',
  },
  image: {
    height: '90%',
  },
});
class NotFound404 extends React.PureComponent<any, any> {
  render() {
    const { classes, title } = this.props;
    return <div style={{ height: '100%', backgroundColor: '#040416' }}>
      {/* <Navbar pageTitle={title || 'Not Found'} shouldDisplayBack={false} /> */}
      <div className={classes.notFound}>
        <img src={error404Image} className={classes.image}/>
      </div>
    </div>;
  }
}

export default injectSheet(styles)(NotFound404);
